/**
 * Google Things to do product categories and the pairs Google refuses together.
 * Source: https://developers.google.com/actions-center/verticals/things-to-do/reference/feed-spec/product-category
 * A listing that carries both halves of a pair is rejected as a whole, so the
 * picker greys out the other half as soon as one is selected.
 */

export const EXCLUSIVE_CATEGORY_PAIRS: ReadonlyArray<readonly [string, string]> = [
    ['family-friendly', 'adults-only'],
    ['guided-tours', 'self-guided'],
    ['small-group-tours', 'private-tours'],
]

/** The category that cannot be combined with `category`, or null. */
export function exclusiveWith(category: string): string | null {
    for (const [a, b] of EXCLUSIVE_CATEGORY_PAIRS) {
        if (a === category) return b
        if (b === category) return a
    }
    return null
}

/** Pairs where both halves are selected. Empty when the selection is valid. */
export function categoryConflicts(selected: string[]): Array<readonly [string, string]> {
    return EXCLUSIVE_CATEGORY_PAIRS.filter(([a, b]) => selected.includes(a) && selected.includes(b))
}

/**
 * Categories that cannot be added to `selected`: the other half of every
 * selected pair, mapped to the category that blocks them. A category that is
 * already selected is never reported, so a conflict stays visible and removable.
 */
export function blockedCategories(selected: string[]): Record<string, string> {
    const blocked: Record<string, string> = {}
    selected.forEach((category) => {
        const other = exclusiveWith(category)
        if (other && !selected.includes(other)) {
            blocked[other] = category
        }
    })
    return blocked
}
